import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=086c5de4"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=086c5de4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports